export enum AssetColumn {
    Filepath,
    RecordType,
    Content,
    AssetType,
    Originator,
    Details,
    Origin,
    Status,
    Updated,
    Created,
    Info
}

export interface AssetListingConfig {
    pageSize: number;
    columns: ConfiguredAssetColumns;
}

type ConfiguredAssetColumns = Record<AssetColumn, ColumnConfig>;

export interface ColumnConfig {
    order: number;
    visible: boolean;
}

export const getDefaultAssetListingConfig = (): AssetListingConfig => ({
    pageSize: 50,
    columns: {
        [AssetColumn.Filepath]: { order: 1, visible: true },
        [AssetColumn.RecordType]: { order: 2, visible: true },
        [AssetColumn.Info]: { order: 3, visible: true },
        [AssetColumn.Content]: { order: 4, visible: true },
        [AssetColumn.AssetType]: { order: 5, visible: true },
        [AssetColumn.Originator]: { order: 6, visible: true },
        [AssetColumn.Details]: { order: 7, visible: true },
        [AssetColumn.Origin]: { order: 8, visible: true },
        [AssetColumn.Status]: { order: 9, visible: true },
        [AssetColumn.Updated]: { order: 10, visible: true },
        [AssetColumn.Created]: { order: 11, visible: true }
    }
});

export const sortColumnsByConfiguredOrder = (columnConfig: ConfiguredAssetColumns): [string, ColumnConfig][] => {
    /* ensures that columns not present in LocalStorage config (i.e. newly added) are present in the listing config modal */
    const allColumns: ConfiguredAssetColumns = { ...getInvisibleDefaultColumns(), ...columnConfig };

    return Object.entries(allColumns).sort(([, column_1], [, column_2]) => column_1.order - column_2.order);
};

const getInvisibleDefaultColumns = () => {
    const defaultColumns = getDefaultAssetListingConfig().columns;
    const entries = Object.entries(defaultColumns).map(([colName, colCfg]) => [colName, { ...colCfg, visible: false }]);

    return Object.fromEntries(entries);
};
